import { createListenerMiddleware, createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { CoreState } from './types';

const initialState: CoreState = {
    drawerWidth: 300,
};

export const listenerMiddleware = createListenerMiddleware();

export const { actions, reducer } = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        init(state) {
            state.drawerWidth = initialState.drawerWidth;
        },

        resizeDrawer(state, { payload: { drawerWidth } }: PayloadAction<{ drawerWidth: number }>) {
            state.drawerWidth = drawerWidth;
        },
    },
});
